import { Mic } from 'lucide-react'
import { StatusBadge } from '@/components/ui/status-badge'

/** Marks an activity that came from a voice memo (the text is always visible, IA-20). */
export function IngesprokenBadge() {
  return (
    <StatusBadge tone="neutral" size="sm" icon={<Mic aria-hidden className="size-3" />}>
      Ingesproken
    </StatusBadge>
  )
}
